import { Builder } from '@builder.io/react'

import { Faq } from './Faq'
import { defaultProps } from './Faq.defaults'

Builder.registerComponent(Faq, {
  name: 'FAQ',
  noWrap: true,
  inputs: [
    {
      name: 'items',
      type: 'array',
      defaultValue: defaultProps.items,
      subFields: [
        {
          name: 'question',
          type: 'richText',
          defaultValue: 'Question',
        },
        {
          name: 'answer',
          type: 'richText',
          defaultValue: 'Answer',
        },
      ],
    },
    {
      name: 'hideJsonLd',
      type: 'boolean',
      friendlyName: 'Hide JSON-LD schema markup',
      defaultValue: defaultProps.hideJsonLd,
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/help-square.svg',
})
